module.exports = __webpack_public_path__ + "img/alert-warn-icon.d00d96ef.svg";